const app = {
  name: "Sistem Perpustakaan",
  company: "SDIT Nurul Islam",
  programYear: {
    active: 2024,
    options: [2023,2024]
  },
  guide: null,
  geko: {
    apiUrl: "https://t4tapi.kolaborasikproject.com/api/",
    user: {
      email: "iyas.muzani@trees4trees.org",
      password: "iyas123"
    }
  },
  logo: {
    sm: "./static/img/logo/logo.png",
    md: "./static/img/logo/logo.png",
    lg: "./static/img/logo/logo.png",
  },
  server: {
    local: "http://localhost:8000/api",
    stagging: "http://localhost:5100",
    development: "https://backend.t4t-api.org/api",
    production: "https://nuris-sdit-perpus.haunansite.com/api",
    demo: "https://backend.t4t-api.org/api"
  },
  download: {
    android: "https://play.google.com/store/",
    ios: "https://www.apple.com/id/app-store/"
  },
  options: {
    allowRegister: false,
    forgetPassword: false,
    autofill: false,
    myAction: false
  },
  apikey: {
    gmap: "",
    instagram:
      "IGQVJYeldoUUw2VG9lbXdzMVY3YnBfc29SMkIyU3BGTXB0eTRlQmV3OUFqLWZAnWkhtLVc1MEJZAUzNncGJSSUZASX2ZArOEV2d0I0X0RqMFJVdGVLWmlKaTF6ZATE1NFkxa3J1Ylg4UzUyYTNacndPNGRBVAZDZD"
  },
  midtrans: {
    merchantID: "G440120185",
    clientKey: "Mid-client-dCaFTR4ecnHo-I0G",
    serverKey: "Mid-server-1KbJAXCq0AZJdtBP9yEFAPxT"
  },
  mapbox: {
    token:
      "pk.eyJ1IjoiYWx1a2FjaCIsImEiOiJ3US1JLXJnIn0.xrpBHCwvzsX76YlO-08kjg",
    mapStyle: "mapbox://styles/mapbox/satellite-streets-v11"
  },
  midtrans: {
    // const snapSrcUrl = 'https://app.sandbox.midtrans.com/snap/snap.js';
    productionUrl: "https://app.midtrans.com/snap/snap.js",
    sandboxUrl: "https://app.sandbox.midtrans.com/snap/snap.js"
  },
  paypal: {
    sandboxAccount: "sb-z9dap25354858@business.example.com",
    sandboxClientId:
      "AdEJo9ioD77oqbJ5mJ9IGhzCpNB8l1HhBvAkD2Uwj3O9mzF6CgP-y_-KE8A7a6IXGYxg0ZMFezYmHmHo",
    sandbox:
      "AdEJo9ioD77oqbJ5mJ9IGhzCpNB8l1HhBvAkD2Uwj3O9mzF6CgP-y_-KE8A7a6IXGYxg0ZMFezYmHmHo",
    production:
      "AfxpBBAY4iY4nlqHE33nhzMDZX8g2TLClo6kREF9yMObuoCkOTUdlW4qnyCRXYswcJAEc"
  }
};

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app;



// WEBPACK FOOTER //
// ./src/config.js